import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-project-cycle.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-project-cycle.component.scss?ngResource";
import { Component } from "@angular/core";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { AddprojectCycleConstants } from "./add-project-cycle.constants";
import { projectCycleFormConstants } from "../shared/project-cycle-form/project-cycle-form.constants";
import { switchMap } from "rxjs";
import { SettingsService } from "../../../settings.service";
import { AttributesAndParametersService } from "../../attributes-and-parameters/shared/services/attributes-and-parameters.service";
import { AppConfig } from "../../../../../app.config";
let AddprojectCycleComponent = class AddprojectCycleComponent {
    activeModal;
    appController;
    settingsService;
    attributesAndParametersService;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    saveLabel = SharedConstants.SAVE_LABEL;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    dialogTitle = AddprojectCycleConstants.COMPONENT_NAME;
    componentType = SharedConstants.ADD_PROJECT_CYCLE_COMPONENT_TYPE;
    valuationRunForm;
    showCompletedCheckbox = false;
    showCopyProjectCycle = true;
    saveprojectCycles;
    attachmentIdList;
    constructor(activeModal, appController, settingsService, attributesAndParametersService) {
        this.activeModal = activeModal;
        this.appController = appController;
        this.settingsService = settingsService;
        this.attributesAndParametersService = attributesAndParametersService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
        this.valuationRunForm = new FormGroup({
            name: new FormControl(null, [Validators.required, Validators.maxLength(250)]),
            description: new FormControl(null, [Validators.required]),
            copyProjectCycle: new FormControl(null),
            copyProjectCycleSelect: new FormControl(false, Validators.required),
            fromDate: new FormControl(null, Validators.required),
            toDate: new FormControl(null, Validators.required),
            projectDocumentation: new FormControl(null, Validators.required)
        });
    }
    ngOnInit() {
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    onBtnSaveClicked() {
        this.valuationRunForm.get(projectCycleFormConstants.PROJECT_DOCUMENTATION_CONTROL).markAsTouched();
        if (this.valuationRunForm.invalid) {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
            return;
        }
        this.attachmentIdList = this.valuationRunForm.get(projectCycleFormConstants.PROJECT_DOCUMENTATION_CONTROL).value.attachmentList.attachmentList;
        const copyChecked = this.valuationRunForm.get(projectCycleFormConstants.COPY_PROJECT_CYCLE_FORM_CONTROL).value;
        this.valuationRunForm.controls[projectCycleFormConstants.COPY_PROJECT_CYCLE_SELECT_FORM_CONTROL].clearValidators();
        this.valuationRunForm.controls[projectCycleFormConstants.COPY_PROJECT_CYCLE_SELECT_FORM_CONTROL].updateValueAndValidity();
        if (copyChecked) {
            this.valuationRunForm.controls[projectCycleFormConstants.COPY_PROJECT_CYCLE_SELECT_FORM_CONTROL].setValidators(Validators.required);
            this.valuationRunForm.controls[projectCycleFormConstants.COPY_PROJECT_CYCLE_SELECT_FORM_CONTROL].updateValueAndValidity();
        }
        let oldId = -1;
        if (this.valuationRunForm.get(projectCycleFormConstants.COPY_PROJECT_CYCLE_FORM_CONTROL).value === true) {
            const params = { $filter: `name eq '${this.valuationRunForm.get(projectCycleFormConstants.COPY_PROJECT_CYCLE_SELECT_FORM_CONTROL).value}'` };
            this.attributesAndParametersService.getprojectCycle(params).subscribe({
                next: (val) => {
                    oldId = val[0].id;
                    this.save(oldId);
                }
            });
        }
        else {
            this.save();
        }
    }
    save(oldId) {
        const newRun = {
            id: oldId,
            name: this.valuationRunForm.get(projectCycleFormConstants.NAME_FORM_CONTROL).value,
            description: this.valuationRunForm.get(projectCycleFormConstants.DESCRIPTION_FORM_CONTROL).value,
            fromDate: this.valuationRunForm.get(projectCycleFormConstants.FROM_DATE_FORM_CONTROL).value,
            toDate: this.valuationRunForm.get(projectCycleFormConstants.TO_DATE_FORM_CONTROL).value,
            moduleId: +this.appController.selectedModuleID
        };
        this.saveprojectCycles = this.settingsService.saveprojectCycles(newRun);
        this.saveprojectCycles.pipe(switchMap(response => {
            const saveAttachmentModel = {
                attachments: []
            };
            this.attachmentIdList.forEach(x => {
                saveAttachmentModel.attachments.push({ attachmentId: x.id, projectCycleId: response.id, deleted: false });
            });
            return this.settingsService.saveProjectCyclesAttachment(response.id, saveAttachmentModel);
        })).subscribe({
            next: (response) => {
                this.saveComplete(true);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.dialogTitle, error, CRUDOperation.Add);
            }
        });
    }
    saveComplete(response) {
        if (response) {
            this.appController.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
            this.activeModal.close(true);
        }
        else {
            this.appController.showMessage(SharedConstants.ADD_FAILED, AlertType.Error);
        }
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService },
        { type: SettingsService },
        { type: AttributesAndParametersService }
    ];
};
AddprojectCycleComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-add-project-cycle",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AddprojectCycleComponent);
export { AddprojectCycleComponent };
